import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-create-task-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class TaskUploadTaskDataApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("tableOfContents.createNewTask"),
            description: this.translation.t("specs.createNewTaskDescription"),
            httpMethod: "POST",
            path: "/taskdata/v1/tasks",

            parameters: [
                {
                    name: "name",
                    description: this.translation.t("parameters.createNewTaskNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "task to create name",
                },
                {
                    name: "description",
                    description: this.translation.t("parameters.createNewTaskDescriptionDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "task description",
                },
                {
                    name: "responsibles",
                    description: this.translation.t("parameters.taskResponsiblesDescription"),
                    in: "body",
                    paramType: "array of uuid's",
                    required: true,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000",
                    ],
                },
                {
                    name: "reviewers",
                    description: this.translation.t("parameters.taskReviewersDescription"),
                    in: "body",
                    paramType: "array of uuid's",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000",
                    ],
                },
                {
                    name: "actionDate",
                    description: this.translation.t("parameters.taskActionDateDescription"),
                    in: "body",
                    paramType: "date",
                    required: true,
                    example: "2021-07-21",
                },
                {
                    name: "linkedControl",
                    description: this.translation.t("parameters.taskLinkedControlDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "comments",
                    description: this.translation.t("parameters.taskCommentsDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "comment on the task",
                },
                {
                    name: "notifications",
                    description: this.translation.t("parameters.taskNotificationsDescription"),
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [4, 5, 11],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
